import { type ScopedThreadRef } from "@cmmd-forge/contracts";
import { selectEnvironmentState, type AppState } from "./store";

export function createThreadDetailHydratedSelector(
  ref: ScopedThreadRef | null | undefined,
): (state: AppState) => boolean {
  return (state) => {
    if (!ref) return false;
    const environmentState = selectEnvironmentState(state, ref.environmentId);
    return Object.hasOwn(environmentState.messageIdsByThreadId, ref.threadId);
  };
}
